// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xz-1";
export var printerIcon = "_xz-0";